export default {
  "error": {
    "required": "الحقل مطلوب",
    "forbiddenSymbols": "بعض الرموز ممنوعة",
    "numeric": "يجب أن يكون  بالأرقام",
    "minMax": "يجب أن يكون الحقل بين {0} و {1} حرف\r\n",
    "email": "البريد الإلكتروني خاطئ",
    "amount": "المبلغ غير صحيح",
    "selectedPlayer": "يرجى تحديد لاعب",
    "passwordsMismatch": "عدم تطابق كلمات المرور",
    "signInUp": {
      "1": "اسم المستخدم غير موجود",
      "2": "كلمة المرور غير صحيحة",
      "4": "يجب أن تحتوي كلمة المرور على أحرف وأرقام من 6 إلى 16 حرفًا",
      "5": "يرجى تقديم عنوان بريد إلكتروني صالح للاستعمال",
      "6": "هذا البريد الإلكتروني غير متصل بأي حساب.",
      "7": "الحقل فارغ ",
      "8": "يجب أن يكون اسم المستخدم من 3 رموز على الأقل",
      "9": "الحد الأقصى للرموز 16",
      "10": "بدون فراغات",
      "422": "أسم المستخدم تم أخذه مسبقا"
    }
  },
  "messages": {
    "joinClubSucces": "تم إرسال طلب الانضمام بنجاح.",
    "createClubSuccess": "تم إنشاء نادي جديد بنجاح.",
    "balanceTransferSuccess": "تم التحويل بنجاح .",
    "waitingForData": "في انتظار البيانات",
    "deleteSuccess": "تم حذف الحساب بنجاح",
    "changePasswordSuccess": "تم تغيير كلمة المرور بنجاح",
    "forgotPasswordSuccess": "تم إرسال طلبك بنجاح",
    "counterMessage1": "إرسال {0} إلى {1}",
    "clubWrongBalanceMessage1": "لديك {0} فقط ولكنك تريد نقل الإجمالي {1} ، الرجاء إضافة clubBalance والمحاولة مرة أخرى",
    "claimBackWrongMessage1": "تريد المطالبة مرة أخرى {0} ولكن {1} لديها {2} فقط",
    "counterMessage2": "سحب {0} من {1}",
    "emailDeleteInfo": "سيتم حذف رسائل البريد الإلكتروني بعد 30 يومًا",
    "subFotterText": "الأحكام والشروط\r",
    "changeRoleConfirmation": "هل أنت متأكد من أنك تريد تغيير أذونات المستخدم",
    "bonusSuccess": "تهانينا ، لقد تلقيت مكافأة {0}!",
    "clubPlayerRemove": "هل أنت متأكد من ترك النادي؟",
    "unableExport": "تقارير التصدير غير متاحة لحسابك\r\n"
  },
  "signInUp": {
    "username": "إسم المستخدم",
    "password": "كلمة السر"
  },
  "maxClaimBack": "الحد الأقصى لاسترداد المطالبة لكل لاعب: {0}",
  "cancel": "إلغاء",
  "confirm": "تأكيد",
  "from": "من",
  "to": "إلى",
  "days": "أيام",
  "trade": "التجارة",
  "sendVip": "أرسل VIP",
  "tradeRecord": "السجل التجاري",
  "all": "الكل",
  "downline": "",
  "allTime": "كل الوقت",
  "last7Days": "آخر 7 أيام",
  "dialogTitleEmail": "البريد الإلكتروني",
  "vipStatusOff": "غير فعال",
  "vipValidDate": "(صالح لمدة 30 يومًا)",
  "logInNow": "تسجيل الدخول الآن",
  "haveAnAccount": "هل لديك حساب؟",
  "dialogTitlePopUp": "نافذة البريد",
  "member": "عضو",
  "manager": "مدير",
  "agent": "وكيل",
  "player": "عضو",
  "userId": "معرف المستخدم",
  "details": "تفاصيل",
  "uplineAgent": "",
  "buyProduct": "شراء المنتج",
  "leagueHeader": "الدوري",
  "gamesCareer": "مهنة الألعاب",
  "total": "مجموع",
  "tips": "نصائح",
  "doYouConfirm": "هل تؤكد ذلك",
  "game": "لعبه",
  "games": "ألعاب",
  "sport": "رياضة",
  "sports": "رياضات",
  "poker": "لعبة البوكر",
  "casino": "كازينوا",
  "liveCasino": "كازينوا مباشر",
  "cashout": "المصروفات",
  "multiBet": "رهان متعدد",
  "systemBet": "رهان النظام",
  "margin": "",
  "theme": "حافة",
  "playerWinnings": "مكاسب اللاعب",
  "winnings": "المكاسب",
  "hand": "اليدين",
  "join": "انضم",
  "joinClub": "انضم إلى النادي",
  "joinUnion": "انضم إلى الاتحاد",
  "createAClub": "إنشاء نادي",
  "codeForClubCreation": "أدخل الرمز لإنشاء النادي",
  "sentTo": "مرسلة إلى",
  "exchange": {
    "chips": "",
    "sapphires": "ياقوت أزرق",
    "currentBalance": "الرصيد الحالي",
    "currentExchange": "التبادل الحالي",
    "sapphireExchange": "",
    "minExchangeAmount": "الحد الأدنى لمبلغ الصرف",
    "convert": "تحويل"
  },
  "createUnion": "إنشاء اتحاد",
  "grandCreditHistory": "تاريخ ائتماني كبير",
  "soundEffects": "مؤثرات صوتية",
  "memberEditing": "تحرير و انشاء عضو",
  "timeSliderName": "وقت العمل",
  "blindSliderName": "",
  "gameLengthSliderName": "وقت اللعب",
  "buyInSliderName": "",
  "minBuyInText": "الحد الأدنى للشراء ",
  "maxBuyInText": "الحد الأقصى للشراء",
  "newTableDialogTitle": "طاولة جديدة",
  "blinds": "الستائر ",
  "clubLeague": "مباريات البطولة",
  "clubCapitalize": "النادي",
  "clubId": "هوية النادي",
  "unionId": "معرّف النقابة",
  "agentId": "رقم تعريف الوكيل",
  "id": "اسم المستخدم",
  "lv": "المعرف",
  "fee": "التكاليف",
  "pokerGames": "ألعاب البوكر",
  "spins": "كامل الكازينوا",
  "bettings": "الرهانات",
  "wl": "الأرباح",
  "nickname": "كنية",
  "lastLogin": "آخر تسجيل دخول",
  "create": "أنشأ",
  "createClub": "إنشاء نادي",
  "selectAvatar": "حدد الصورة الرمزية",
  "selectCountry": "حدد الدولة",
  "clubCreation": "إنشاء النادي",
  "clubDescriptionAndRules": "وصف وقواعد النادي",
  "hands": "اليدين",
  "validFor": "صالحة ل",
  "levelUpdate": "تحديث المستوى",
  "wantToBuy": "هل تريد ان تشتري",
  "ourSubItem": "البند الفرعي لدينا",
  "createNewClub": "إنشاء نادي جديد",
  "joinNewClub": "التحق بالنادي",
  "clubName": "اسم النادي",
  "clubNotice": "رأي النادي",
  "content": "المحتوى",
  "clubDisband": "هل أنت متأكد أنك تريد حل النادي؟",
  "deleteClubMember": "هل أنت متأكد أنك تريد حذف هذا العضو؟",
  "changeRole": "تأكيد لتغيير دور المستخدم؟",
  "changeRoleFromAgent": "ستتم إزالة بيانات الخط النازل الحالي إذا قمت بتغيير حقوق هذا الوكيل. هل أنت واثق؟",
  "freeToRename": "مجانا لإعادة تسميتها لأول مرة",
  "welcomeMessagePart1": "مرحبا بك في",
  "welcomeMessagePart2": "للاستفسارات يرجى الاتصال",
  "loadingTablesList": "تحميل قائمة الجداول ...",
  "notificationIsValid": "كل إخطار صالح لمدة 24 ساعة",
  "jackpot": "الفوز بالجائزة الكبرى",
  "commision": "عمولة",
  "selectDownline": "",
  "recruitedByTheAgent": "يرجى وضع علامة على اللاعبين الذين عينهم الوكيل",
  "levelHasExpired": "انتهى مستوى ناديك ، يرجى التجديد.",
  "grantSendOutLimit": "حد إرسال وكيل المنحة",
  "currentDownline": "Downline الحالي",
  "agentManagement": "إدارة الوكيل",
  "wantToChangeDownline": "هل أنت متأكد أنك تريد تغيير ",
  "wantToRemove": "هل أنت متأكد أنك تريد حذف",
  "notifications": "إشعارات",
  "quitTheClub": "ترك النادي",
  "oddDefaultFormat": "الشكل الطبيعي للكوتا",
  "clubChipBalance": "رصيد Club Token",
  "exchangeSapphires": "",
  "multipleOf100": "يرجى إدخال مضاعف متكامل من 100",
  "clubEditing": "",
  "startAnewTable": "ابدأ جدولًا جديدًا",
  "change": "تغيير",
  "coins": "عملات معدنية",
  "items": "العناصر",
  "sapphires": "",
  "clubHeadline1": "لا يمكن إنكار حقيقة أن نجاح الإعلان يكمن في الغالب في العنوان الرئيسي. يجب أن يجذب العنوان",
  "showMore": "أظهر المزيد",
  "clubHeadline2": "",
  "showLess": "",
  "disbandClub": "",
  "disbandUnion": "",
  "quitTheUnion": "",
  "overall": "شاملة",
  "yesterday": "في الامس",
  "past7Days": "اخر 7 ايام",
  "select": "تحديد",
  "overallWinnings": "المكاسب الإجمالية",
  "pokerWinnings": "مكاسب البوكر",
  "casinoWinnings": "مكاسب كازينو",
  "bettingWinnings": "مكاسب الرهان",
  "pokerFeeAmount": "مبلغ رسوم البوكار",
  "pokerFee": "رسوم البوكار",
  "gamesPoker": "ألعاب البوكر",
  "spinsCasino": "جولات الكازينو",
  "deleteMember": "إزالة العضو",
  "dateCreated": "الوقت المرفق",
  "chipBalance": "توازن الرقائق",
  "sent": "شحنها",
  "totalChips": "مجموع الرموز المميزة للاعب باستثناء الرموز المميزة في اللعب",
  "yourChipsAmount": "كمية الرقائق الخاصة بك",
  "claimedBack": "المطالبات",
  "tradeCommission": "تم خصم {0}٪ من العمولة على هذا النشاط التجاري",
  "areComingSoon": "يصل قريبا",
  "nlh": "",
  "plo": "",
  "ofc": "",
  "ringGame": "لعبة الحلقة",
  "sng": "",
  "mtt": "",
  "regularMode": "الانتظام",
  "progressiveMode": "تطور",
  "ultimateMode": "نهائي",
  "sixPlus": "6",
  "fourCard": "4 بطاقات",
  "fiveCard": "5 بطاقات",
  "concurrent": "منافس",
  "sequential": "تسلسلي",
  "operationSequence": "تسلسل العملية",
  "autoStart": "بدء تلقائي",
  "autoExtension": "تمديد الآلي",
  "times": "تايمز",
  "autoOpen": "الفتح التلقائي",
  "riskManagement": "إدارة المخاطر",
  "multiTimeRun": "قم بتشغيله عدة مرات",
  "evChop": "",
  "cap": "قبعة",
  "callTime": "وقت الاتصال",
  "autorizedToBuyin": "الموافقة على الشراء",
  "byh": "الحصول عليه في يدك",
  "gpsRestriction": "قيود gps",
  "ipRestriction": "تقييد IP",
  "banChatting": "حظر الدردشة",
  "tableCost": "تكلفة الجدول",
  "balance": "توازن",
  "grantCredit": "منح الائتمان",
  "selectDownlineText": "حدد اللاعبين الذين تريد تعيينهم لهذا الخط",
  "creditBalance": "الرصيد الدائن",
  "grantCreditText": "من هنا يمكنك إرسال وجمع رموز النادي",
  "unionClubs": "اتحاد",
  "unionJoinRequests": "طلبات الانضمام ",
  "unionData": "بيانات الاتحاد",
  "unionEditingContent": {
    "change": "تغيير",
    "label": "اسم الاتحاد",
    "notice": "حرية التسمية المرة الأولى",
    "save": " حفظ / تسجيل",
    "price": "التسجيل",
    "notEnough": {
      "0": "لا تملك saphirs",
      "1": "اضغط هنا",
      "2": "شراء saphirs"
    }
  },
  "information": "معلومات",
  "dataIsRecordedBasedOnUnionHeadData": "يتم تسجيل البيانات بناءً على المنطقة الزمنية لرئيس الاتحاد:",
  "pokerWinLossFee": "فوز / خسارة + رسوم بوكر",
  "pokerWinLossFeeOverall": "شاملة",
  "pokerWinLossFeeLastWeek": "أخر أسبوع ",
  "pokerWinLossFeeThisWeek": "هذا الاسبوع",
  "suspend": "تعليق",
  "remove": "إزالة",
  "exportData": "تصدير البيانات",
  "betYourHand": {
    "combinations": "تركيبات",
    "amount": "x1 / x2",
    "max": "",
    "nlh": {
      "0": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "1": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "2": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "3": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "4": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "5": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "6": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "7": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "8": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      }
    },
    "plo": {
      "0": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "1": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "2": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "3": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "4": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "5": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "6": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      },
      "7": {
        "title": "",
        "description": "",
        "amount": "",
        "max": "",
        "combinations": ""
      }
    }
  },
  "exportRecord": "تسجيل التصدير",
  "exportDate": "تاريخ التصدير",
  "pleaseEnterValidEmail": "يرجى إدخال البريد الإلكتروني الصحيح",
  "playerData": "بيانات اللاعب",
  "sapphireStatement": "",
  "tradeRecords": "ملفات تجارية",
  "upgradeToJoinText": "يجب أن يكون ناديك من الدرجة 2 أو أعلى للانضمام إلى الاتحاد",
  "upgradeToCreateText": "يجب أن يكون ناديك من الرتبة 2 أو أعلى لإنشاء اتحاد",
  "clubDataHelp": [
    ["", "عرض البيانات منذ انضمام المستخدم إلى النادي"],
    ["اخر 7 ايام","يعرض البيانات لآخر 7 أيام"],
    ["تحديد","يعرض البيانات للتواريخ المحددة."],
    ["المكاسب الإجمالية","يعرض بيانات عن عدد الرموز التي ربحها / فقدها المستخدم في جميع الألعاب."],
    ["مرابيح البوكر","يعرض بيانات عن عدد الرقائق التي فاز بها / فقدها مستخدمو البوكر."],
    ["أرباح الكازينوا","يعرض بيانات عن عدد الرقائق التي فاز بها / فقدها مستخدمو ألعاب الكازينو."],
    ["مبلغ الرسوم","يشير إلى مبلغ رسوم البوكر المحولة إلى النادي"]
  ],
  "footer": {
    "items": {
      "home": "ترحيب",
      "shop": "متجر",
      "career": "مسار مهني",
      "profile": "الملف الشخصي",
      "messages": "الرسائل",
      "settings": "الإعدادات",
      "data": "المعطيات",
      "members": "أفراد",
      "counter": "عداد"
    }
  },
  "agentDetails": {
    "memberAmount": "مبلغ العضو {0}"
  },
  "language": {
    "en": "الإنجليزية",
    "tur": "اللغة التركية",
    "id": "الإندونيسية",
    "de": "ألمانية"
  },
  "dialog": {
    "tutorial": "الدورة التعليمية",
    "createClub": "إنشاء نادي",
    "createAClub": "إنشاء نادي",
    "joinClub": "انضم إلى النادي",
    "selectAvatar": "حدد صورة رمزية",
    "selectCountry": "اختر الدولة",
    "coins": "قطع نقدية",
    "notification": "تنبيه",
    "sapphires": "الياقوت",
    "exchange": "تبادل",
    "editClub": "إصدار النادي",
    "disbandClub": "حل النادي",
    "disbandUnion": "حل الاتحاد",
    "deleteMember": "التأكيد",
    "editMemberInfo": "تحرير معلومات العضو",
    "changeRole": "التأكيد",
    "mission": "البعثات",
    "unionNotice": "إشعار نقابي",
    "joinUnion": "توحيد",
    "createUnion": "إنشاء اتحاد",
    "createLabel": "أدخل اسم النقابة",
    "joinLabel": "أدخل معرف الاتحاد",
    "unionAuthority": "سلطة",
    "selectAuthority": {
      "text": "حدد السلطة لإنشاء جداول البوكر",
      "current": "الملاك الحاليين والمديرين",
      "all": "جميع مالكي ومديري الأندية"
    },
    "unionConfirm": "تأكيد",
    "unionTerms": {
      "one": "1. يمكن فقط للنوادي التي تحمل نجمتين أو أكثر إنشاء اتحاد أو الانضمام إليه.",
      "two": "2. بعد إنشاء اتحاد أو الانضمام إليه ، ستظل رقائق  المحفوظة في ناديك متاحة في هذا الاتحاد بالذات. ومع ذلك ، سيتم إزالة الرقائق التي يحتفظ بها الوكلاء واللاعبون",
      "agreement": "قرأت الشروط و الأحكام "
    },
    "clubDetails": "معلومات النادي",
    "upgradeToCreate": "استحالة انشاء اتحاد",
    "upgradeToJoin": "غير على الانضام لنقابة",
    "unionConfirmation": "معلومات الاتحاد",
    "clubConfirmation": "معلومات النادي",
    "renewLevel": "غير قادر على انشاء طاولة",
    "agentDetails": "تفاصيل الوكيل",
    "quitTheUnion": "الخروج من الاتحاد",
    "export": "تصدير",
    "notEnoughFunds": "لا يوجد رصيد كافي",
    "memberMenu": "معلومات النادي",
    "clubInfo": "المعلومات حول النادي",
    "betYourHand": "الحظ"
  },
  "settings": {
    "text": "الاعدادات",
    "twoStepVerification": "التحقق من خطوتين",
    "changePassword": "تغير كلمة العبور",
    "changeEmail": "تغير البريد الالكتروني",
    "languages": "اللغات",
    "avatar": "اللغات",
    "details": "الصورة الرمزية",
    "linkEmail": "ربط بريدك الالكتروني",
    "language": "اللغة",
    "select": "تحديد ",
    "logOut": "تسجيل الخروج"
  },
  "clubLevelName": {
    "1": "نادي بنجمة واحدة",
    "2": "نادي بنجمتين",
    "3": "نادي بثلاثة نجمات ",
    "4": "نادي ب أربعة نجمات ",
    "5": "نادي بخمسة نجمات",
    "6": "نادي بستة نجمات",
    "7": "نادي بسبعة نجمات",
    "8": "نادي بثمانية نجمات",
    "9": "نادي بتسعة نجمات",
    "10": "نادي بعشرة نجمات",
    "11": "سوبر ستار النادي"
  },
  "changePassword": {
    "text": "تغير كلمة العبور",
    "current": "كلمة العبور الحالية",
    "new": "كلمة العبور الجديدة",
    "repeat": "تأكيد كلمة العبور",
    "confirm": "تأكيد"
  },
  "linkEmail": {
    "text": "ربط بريدك الالكتروني",
    "writeYourEmail": "كتابة البريد الالكتروني ليصلك رمز للتأكيد",
    "emailAddress": "البريد الالكتروني",
    "resendCode": "اعادة ارسال رمز التأكيد",
    "checkYourMail": "يرجي التثبت من الصندوق البريدي لبريدك الالكتروني"
  },
  "passwordRecovery": {
    "emailField": "البريد الالكتروني",
    "title": "استرجاع كلمة العبور",
    "description": "يرجي كتابة البريد الالكتروني الذي قمت بادراجه عند عملة التسجيل",
    "sendEmail": "ارسال عبر البريد الالكتروني",
    "successDescription": "نرسل لك كلمة مرور مؤقتة جديدة. يمكنك استخدامه لدخول اللعبة ، بعد تسجيل الدخول يمكنك تغيير كلمة المرور في قائمة إعدادات اللعبة\r\n",
    "goBack": "الرجوع"
  },
  "tutorial": {
    "text": "",
    "accountSettings": "اعدادات الحساب",
    "leagueGames": "ألعاب كرة القدم",
    "clubs": "الأندية",
    "shop": "المتجر",
    "dailyBonus": "المكافات اليومية ",
    "accountLevelsAndXP": "درجة الحساب xp",
    "friendInvite": "دعوة صديق"
  },
  "about": {
    "text": "حول",
    "gameRules": "شروط اللعب",
    "contactInfo": "معلومات الاتصال",
    "termsAndConditions": "الشروط و الأحكام",
    "privacyPolicy": "سياسة و أحكام"
  },
  "leaderboard": {
    "text": "الترتيب",
    "remaining": "الوقت المتبقي",
    "rank": "المرتبة",
    "name": "الاسم",
    "points": "نقاطك",
    "reward": "المكفأة",
    "daily": "اليومي",
    "weekly": "الأسبوعي",
    "monthly": "الشهري"
  },
  "leaderboardInfo": {
    "text": "معلومات حول الترتيب",
    "hints": "النصائح",
    "rewards": "المكافاءات و الجوائز"
  },
  "leaderboardHints": {
    "text": "النصائح",
    "rule": "من خلال اللعب في الدوري أو لاعب النادي ، سيكسب نقاطًا ويشارك في ألواح المتصدرين. في نهاية الموقت ، سيحصل اللاعبون في المراكز العشرة الأولى على مكافآت.",
    "hintsText": {
      "0": {
        "header": "نصيحة 1",
        "text": "يمكنك كسب نقاط المتصدرين من خلال لعب البوكر وألعاب الكازينو والرهانات في الدوري والنوادي."
      },
      "1": {
        "header": "نصيحة 2",
        "text": "يمنحك لعب المباريات والقيام بالمراهنات في الأندية نقاطًا أكثر من ألعاب الدوري"
      },
      "2": {
        "header": "نصيحة 3",
        "text": "يتم تحديد النقاط بمقدار المال الذي تربحه ، وسيمنحك الرهان الكبير مكافأة أكبر والعديد من النقاط."
      },
      "3": {
        "header": "نصيحة 4",
        "text": "سيتم إعادة تعيين نقاطك عندما ينتهي المؤقت. ولكن إذا لم تتمكن من الوصول إلى المراكز العشرين الأولى في ألواح المتصدرين اليومية ، فستظل لديك فرصة لزيادة هذه النقاط والدخول إلى المراكز العشرين الأولى في ألواح المتصدرين الأسبوعية أو الشهرية."
      }
    }
  },
  "level": {
    "currentXp": "المستوى الحالي ",
    "requiredXp": "المستوى المطلوب",
    "gainXp": "العب البوكر أو الكازينو أو قم به من أجل كسب مستوى  والارتقاء",
    "accountLevel": "مستوى الحساب",
    "levelRewards": "مكافاءات المستوى"
  },
  "shop": {
    "text": "المتجر",
    "coins": {
      "text": "العملة"
    },
    "items": {
      "text": "مقالات",
      "silverCard": "البطاقة الفضية",
      "goldCard": "بطاقة ذهبية",
      "platinumCard": "البطاقة البلاتينية",
      "avatars": "",
      "emojis": "الرموز التعبيرية"
    },
    "sapphires": {
      "text": "الياقوت\r"
    },
    "mostPopular": "الأكثر شعبية",
    "bestValue": "القيمة الأفضل"
  },
  "support": {
    "text": "الدعم"
  },
  "time": {
    "s15": "15 ثانية",
    "s20": "20 ثانية",
    "s30": "30 ثانية"
  },
  "number": {
    "one": "1",
    "onePointFive": "1.5",
    "two": "2",
    "twoPointFive": "2.5",
    "three": "3",
    "fout": "4",
    "five": "5",
    "six": "6"
  },
  "dash": {
    "claimBack": "ابلاغ",
    "buyIn": "شراء الي"
  },
  "button": {
    "ok": "موافق",
    "confirm": "تأكيد",
    "cancel": "الغاء",
    "claimBack": "ابلاغ",
    "sendOut": "ارسال",
    "send": "ارسال",
    "oneMore": "اضافي واحد",
    "buy": "شراء",
    "done": "انهاء",
    "submit": "ارسال ",
    "quit": "مغادرة النادي",
    "sapphire": "الياقوت",
    "select": "تحديد",
    "save": "انقاذ",
    "sendVip": "ارسال vip",
    "upgrade": "تحسين",
    "close": "اغلاق",
    "create": "انشاء",
    "join": "انظمام",
    "apply": "تطبيق",
    "claim": "المطالبة"
  },
  "header": {
    "clubData": "معومات النادي",
    "clubDetails": "تفاصيل النادي",
    "clubChips": "عملة النادي",
    "clubRating": "تطور النادي",
    "title": "عنوان"
  },
  "playerMenu": {
    "playerMenuTitle": "تفاصيل اللاعبين",
    "trade": "انجاز تجاري",
    "jackpot": "الفوز بالجائزة الكبرى",
    "quit": "مغادرة النادي"
  },
  "agentMenu": {
    "agentMenuTitle": "معلومات الوكيل ",
    "grantCredit": "تمديد الدين // انشاء دين"
  },
  "career": {
    "items": {
      "poker": "اليدين",
      "sportsbook": "مراهنة",
      "casino": "مراهنة "
    },
    "periods": {
      "day": " اليوم",
      "month": "الشهر",
      "year": "السنة"
    },
    "range": {
      "all": "كل الأوقات",
      "lastWeek": "أخر 7 أيام ",
      "purchase": "شراء بطاقة ذهبية لمعلومات الأكثر"
    },
    "reports": {
      "game": "اللعبة",
      "hand": "اليدين"
    },
    "menu": {
      "filters": "التصفية"
    },
    "menuRow": {
      "all": "الكل",
      "poker": "بوكر",
      "casino": "كازينوا",
      "betting": "الرهان"
    }
  },
  "options": {
    "clubChips": "",
    "newMessage": "الاشعارات",
    "buyLevel": "ترتيب الأندية",
    "promotion": "الترقيات و العروض",
    "disband": "انزال النادي",
    "leftDays": "الأيام المتبقية",
    "grandCredit": "تواريخ الدين الكبير",
    "quit": "مغادرة النادي"
  },
  "union": {
    "clubs": "نادي الاتحاد",
    "requests": " الانضمام للطلبات",
    "data": "معلومات الاتحاد",
    "authority": "الترخيص في انشاء طاولة بوكر",
    "disband": "اسقاط الاتحاد",
    "quit": "مغادرة الاتحاد"
  },
  "club": {
    "text": "النادي",
    "poker": "بوكر",
    "betting": "الرهان",
    "casino": "كازينوا",
    "games": {
      "poker": {
        "admin": "حاليا ، ألعاب الكازينو غير متوفرة. من أجل إتاحته ، يرجى تجديد تصنيف ناديك",
        "member": "لا توجد حاليا طاولة بوكار متاحة"
      },
      "casino": {
        "admin": "حاليا ، ألعاب الكازينو غير متوفرة. من أجل إتاحته ، يرجى تجديد تصنيف ناديك",
        "member": "ألعاب الكازينوا غير متاحة حاليا"
      },
      "betting": {
        "admin": "حاليا ، الرهانات غير متاحة. من أجل إتاحته ، يرجى تجديد تصنيف ناديك",
        "member": "الرهانات غير متاحة حاليا"
      },
      "renew": "تجديد"
    }
  },
  "clubItems": {
    "options": "خيارات النادي",
    "notifications": "الاشعارات",
    "members": "بيانات اللاعب",
    "counter": "العداد",
    "tradeRecords": "السجل التجاري",
    "memberDetails": "بيانات اللاعب",
    "clubRatings": "تطور النادي",
    "claimBack": "الابلاغ",
    "sendOut": "ارسال",
    "data": "بيانات النادي",
    "union": "الاتحاد",
    "unionEditing": "تعديل الاتحاد",
    "agentMenu": "قائمة الوكيل"
  },
  "memberDetails": {
    "trackPlayer": "لاعبين الحلبة",
    "roleSelection": "اختيار الدور",
    "clubRatings": "ملاحظات النادي",
    "editMemberInfo": {
      "alias": "أضف أسماء مستعارة",
      "notes": "أضف ملاحظات"
    }
  },
  "tradeDirection": {
    "sent": "أرسلت إلى:",
    "claimedBack": "مطالبة من:"
  },
  "members": "عضو",
  "newMembers": "عضو جديد",
  "betting": "الرهانات ",
  "title": "العنوان",
  "chips": "",
  "currentPassword": "كلمة المرور الحالية",
  "newPassword": "كلمة سر جديدة",
  "repeatPassword": "اعادة كلمة العبور ",
  "email": "البريد الالكتروني ",
  "login": "تسجيل الدخول",
  "version": "الإصدار",
  "loginObj": {
    "text": "لا تملك حساب بعد ؟",
    "link": "سجل الان!"
  },
  "registerObj": {
    "text": "هل لديك حساب؟",
    "link": "تسجيل الدخول "
  },
  "forgotPassword": "هل نسيت كلمة المرور",
  "loginBonus": "مكافأة تسجيل الدخول",
  "insurance": "التأمينات",
  "totalPokerFees": "إجمالي رسوم البوكر",
  "pokerFees": "رسوم البوكر",
  "totalWinnings": "جميع المكاسب و الأرباح ",
  "winningsLastWeek": "مكاسب و أرباح الأسبوع الفارط",
  "winningsThisweek": "مكاسب و أرباح  هذا الأسبوع",
  "downlinesChips": "رقائق Downline",
  "chipsInPlay": ""
};